import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule as PrimeNgSharedModule } from 'primeng/api';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { providePrimeNG } from 'primeng/config';
import { NgIdleModule } from '@ng-idle/core';
import { AppComponent } from './app.component';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { Auth0ConfigService } from './shared/services/auth0-config.service';
import { UrlParamsService } from './shared/services/url-params.service';
import { ErrorCatchingInterceptor } from './shared/interceptors/error-catching/error-catching.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LeftSidebarMenuComponent } from '@components/left-sidebar-menu/left-sidebar-menu.component';
import { AgilityToastComponent } from '@agility-components/elements/agility-toast/agility-toast.component';
import { AgilityLoadingSpinnerComponent } from './agility-components/agility-loading-spinner/agility-loading-spinner.component';

// Default Theme Preset
import { AgilityPreset } from 'src/assets/css/themes/presets';


@NgModule({
  declarations: [AppComponent],
  imports: [
    LeftSidebarMenuComponent,
    AgilityLoadingSpinnerComponent,
    BrowserModule,
    BrowserAnimationsModule,
    PrimeNgSharedModule,
    SharedModule.forRoot(),
    AppRoutingModule,
    NgIdleModule.forRoot(),
    InfiniteScrollDirective,
    AuthModule.forRoot({
      ...(() => {
        const configService = new Auth0ConfigService();
        return configService.getConfig().auth;
      })(),
      skipRedirectCallback: new UrlParamsService(document).hasErrorParams(),
      httpInterceptor: (() => {
        const configService = new Auth0ConfigService();
        return configService.getConfig().httpInterceptor;
      })(),
    }),
    AgilityToastComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorCatchingInterceptor,
      multi: true,
    },
    providePrimeNG({
      ripple: false,
      theme: {
        preset: AgilityPreset,
        options: {
          darkModeSelector: '.agility-dark',
          cssLayer: {
            name: 'agility-theme',
            order: 'base, primeng',
          },
        },
      },
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
